import { render, staticRenderFns } from "./processAccidentReceptionPlan.vue?vue&type=template&id=4340765a"
import script from "./processAccidentReceptionPlan.vue?vue&type=script&lang=js"
export * from "./processAccidentReceptionPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4340765a')) {
      api.createRecord('4340765a', component.options)
    } else {
      api.reload('4340765a', component.options)
    }
    module.hot.accept("./processAccidentReceptionPlan.vue?vue&type=template&id=4340765a", function () {
      api.rerender('4340765a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/rec/processAccidentReceptionPlan.vue"
export default component.exports